import React, { PropsWithChildren, ReactNode } from 'react';
import { Box, FormControlLabel, FormControlLabelProps, Typography } from '@material-ui/core';
import styled from 'styled-components';

const SettingsPanelCard = styled(Box)`
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.98) 0%,
    rgba(247, 247, 247, 0.98) 100%
  );
  border: 1px solid ${p => p.theme.palette.divider};
  border-radius: ${p => p.theme.spacing(2)}px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${p => p.theme.spacing(2)}px;
  max-width: 560px;
  padding: ${p => p.theme.spacing(2.5)}px;
  width: 100%;
`;

const SettingsPanelHeader = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: ${p => p.theme.spacing(0.75)}px;
`;

const SettingsPanelDescription = styled(Typography)`
  color: ${p => p.theme.palette.text.secondary};
`;

export const SettingsPanelOptions = styled(Box)`
  display: grid;
  gap: ${p => p.theme.spacing(1.25)}px;
`;

const ToggleOptionRoot = styled(FormControlLabel)`
  && {
    align-items: center;
    background: ${p => p.theme.palette.background.paper};
    border: 1px solid rgba(15, 23, 42, 0.08);
    border-radius: 14px;
    display: flex;
    justify-content: space-between;
    margin: 0;
    min-height: 64px;
    padding: ${p => p.theme.spacing(1.5, 2)};
    width: 100%;
  }

  .MuiFormControlLabel-label {
    flex: 1 1 auto;
    min-width: 0;
    padding-right: ${p => p.theme.spacing(2)}px;
  }

  .MuiSwitch-root {
    margin-right: ${p => p.theme.spacing(-0.5)}px;
  }

  ${p => p.theme.breakpoints.down('sm')} {
    && {
      align-items: flex-start;
      gap: ${p => p.theme.spacing(1)}px;
    }

    .MuiSwitch-root {
      margin-left: ${p => p.theme.spacing(-1)}px;
    }
  }
`;

interface SettingsPanelProps {
  title: ReactNode;
  description?: ReactNode;
}

export const SettingsPanel = ({
  title,
  description,
  children
}: PropsWithChildren<SettingsPanelProps>) => (
  <SettingsPanelCard>
    <SettingsPanelHeader>
      <Typography variant="subtitle2">{title}</Typography>
      {description ? (
        <SettingsPanelDescription variant="body2">
          {description}
        </SettingsPanelDescription>
      ) : null}
    </SettingsPanelHeader>
    {children}
  </SettingsPanelCard>
);

export const SettingsToggleOption = (props: FormControlLabelProps) => (
  <ToggleOptionRoot labelPlacement="start" {...props} />
);